<template>
  <div :class="[`patient-events__item--${payload.priority}`]">
    <div class="patient-events__item-content">
      <p><span class="key">Message:</span> <span>{{ payload.description }}</span></p>
      <p v-if="payload.resolved_by"><span class="key">Acknowledged By:</span> <span>{{ payload.resolved_by }} on {{ $helpers.formatDate(payload.resolved_at) }}</span></p>
    </div>
  </div>
</template>

<script>
export default {
  name: "AiEvent",
  props: {
    payload: { type: Object, required: true }
  }
}
</script>

<style scoped lang="scss">
  .patient-events__item--low {
    .patient-events__item-content {
      background: #c8ddff;
    }
  }
  .patient-events__item--medium {
    .patient-events__item-content {
      background: #ffe0b2;
    }
  }
  .patient-events__item--high {
    .patient-events__item-content {
      background: #ffa6a6;
    }
  }
</style>
